/**
 * Keeps track for "Special Voayage Bulk", meaning deviations that are not connected to a bulk tank.
 * We create a virtual bulk tank to keep the same logic.
 */

var VRC = VRC || {};

VRC.SpecialBulkTanks = (function () {

	var _bulkTanks = [];

	var DEVIATION_ID = -10;

	var initDeviationTank = function () {
		_bulkTanks.push(VRC.BulkTank({
			bulkTankId: DEVIATION_ID,
			tankName: "Deviations",
			tankType: 'All deviations from loading actions. Offload deviations is located on each tank.'
		}));
	};

	var init = function (deviations) {
		initDeviationTank(deviations);
	};

	var getBulkTankById = function (bulkTankId) {
		return _.find(_bulkTanks, function (bulkTank) {
			return bulkTank.getBulkTankId() === bulkTankId;
		});
	};

	var getDeviationTank = function () {
		return getBulkTankById(DEVIATION_ID);
	};

	var toJson = function () {
		var deviationTank = getDeviationTank();
		var deviationJson = deviationTank.toJson();

		return deviationJson;

	};

	return {
		init: init,
		getDeviationTank: getDeviationTank,
		getBulkTankById: getBulkTankById,
		toJson: toJson
	}
})();
